export default {
  future: '%s',
  past: 'fa %s',
  s: 'pochi secondi',
  ss: '%d secondi',
  m: 'un minuto',
  mm: '%d minuti',
  h: "un'ora",
  hh: '%d ore',
  d: 'un giorno',
  dd: '%d giorni',
  M: 'un mese',
  MM: '%d mesi',
  y: 'un anno',
  yy: '%d anni'
};
